export const BrnhTransferColumnDefs = [
    { isHeader: true, header: 'Detailed Table' },
    {
        id: 1, header: 'Sr. No.',
        exportHead: 'SR',
        field: 'srNo',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 40
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'number', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 2, header: 'Dest. City',
        exportHead: 'Dest. City',
        field: 'DestinationCity',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 100
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 3, header: 'Destination Branch',
        exportHead: 'Dest. Branch',
        field: 'DestinationBranch',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 100
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 4, header: 'LR No.',
        exportHead: 'LR No.',
        field: 'LRNO',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 5, header: 'Send.Name',
        exportHead: 'Send.Name',
        field: 'Sender',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 100
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 6, header: 'Rec. Name',
        exportHead: 'Rec. Name',
        field: 'RecName',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 100
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 7, header: 'ItemType (Quantity)',
        exportHead: 'ItemType (Qty)',
        field: 'ItemType',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 95
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 8, header: 'PayType',
        exportHead: 'PayType',
        field: 'PaymentType',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 9, header: 'Freight',
        exportHead: 'Freight',
        field: 'Freight',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 10, header: 'Cartage',
        exportHead: 'Cartage',
        field: 'AllCartage',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 11, header: 'Hamali',
        exportHead: 'Hamali',
        field: 'AllHamali',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'number', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 12, header: 'Valuation',
        exportHead: 'Valuation',
        field: 'Valuation',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 13, header: 'Other Charge',
        exportHead: 'Other Charge',
        field: 'OtherChg',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 14, header: 'GST',
        exportHead: 'GST',
        field: 'ServiceTaxAmount',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 15, header: 'AllTotal',
        exportHead: 'All Total',
        field: 'totalplusGST',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'quantity', dataFormatter: null, minCellWidth: 4 },
    },
    {
        id: 16, header: 'Comments',
        exportHead: 'Comments',
        field: 'Remarks',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null },
    },
    {
        id: 16, header: 'EWB- NO',
        exportHead: 'EWB-NO',
        field: 'EWayBillNo',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null },
    },
    {
        id: 16, header: 'EWB Status',
        exportHead: 'EWB Status',
        field: 'EWayBillStatus2',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: false,
        xlCol: { dataType: 'string', dataFormatter: null },
    },
    { isHeader: true, header: 'Summary Table' },
    {
        id: 17, header: 'Payment Type',
        exportHead: 'Payment Type',
        field: 'PaymentType',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'left', fontSize: 12, minCellWidth: 90
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'string', dataFormatter: null, },
    },
    {
        id: 18, header: 'Total Freight',
        exportHead: 'Total Freight',
        field: 'Freight',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 19, header: 'Total Cartage',
        exportHead: 'Total Cartage',
        field: 'AllCartage',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 20, header: 'Total Hamali',
        exportHead: 'Total Hamali',
        field: 'AllHamali',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 21, header: 'Total Valuation',
        exportHead: 'Total Valuation',
        field: 'Valuation',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 22, header: 'Total Other Charges',
        exportHead: 'Total Other Charges',
        field: 'OtherChg',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 23, header: 'Total Amount',
        exportHead: 'Total Amount',
        field: 'total',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 24, header: 'Total GST',
        exportHead: 'Total GST',
        field: 'ServiceTaxAmount',
        isSelected: true, isDefault: false, isMandatory: false,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
    {
        id: 25, header: 'Total+GST',
        exportHead: 'Total+GST',
        field: 'totalplusGST',
        isSelected: true, isDefault: true, isMandatory: true,
        pdfColSx: {
            minCellHeight: 36,   textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', valign: 'middle', halign: 'right', fontSize: 12, minCellWidth: 80
        },
        isSummaryHeader: true,
        xlCol: { dataType: 'number', dataFormatter: null, },
    },
]